/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/validate.js');

export function forms() {

  $('input').on('focus', function () {
    $(this)
      .parent()
      .addClass('focused');

    $(this)
      .parent()
      .parent()
      .addClass('focused');
  });

  $('input').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .parent()
        .removeClass('focused');

      $(this)
        .parent()
        .parent()
        .removeClass('focused');
    }
  });

  $('textarea').on('focus', function () {
    $(this)
      .parent()
      .addClass('focused');
  });

  $('textarea').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .parent()
        .removeClass('focused');
    }
  });

  // Gravity forms
  $('.gfield input.medium').parent() .parent().addClass('medium');

  $('.gfield input').on('focus', function () {
    $(this)
      .parent()
      .parent()
      .addClass('focused');
  });

  $('.gfield input').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .parent()
        .parent()
        .removeClass('focused');
    }
  });

  $('.gfield .textarea').on('focus', function () {
    $(this)
      .parent()
      .parent()
      .addClass('focused');
  });

  $('.gfield .textarea').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .parent()
        .parent()
        .removeClass('focused');
    }
  });
}
